import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import VCharts from "v-charts";
import Print from 'vue-print-nb'

import "@/styles/index.scss"; // global css

import App from "./App";
import router from "./router";
import store from "./store";
import directive from './directive' // directive
import VueAMap from "vue-amap";

import "@/icons"; // icon
import "@/permission"; // permission control
import XLSX from "xlsx";
Vue.prototype.getMedicineRate = function(starRate) {
  if (starRate != null && starRate >= 1 && starRate <= 14) {
    if (starRate == 1) {
      return '5%'
    }
    if (starRate == 2) {
      return '10%'
    }
    if (starRate == 3) {
      return '15%'
    }
    if (starRate == 4) {
      return '20%'
    }
    if (starRate == 5) {
      return '25%'
    }
    if (starRate == 6) {
      return '30%'
    }
    if (starRate == 7) {
      return '35%'
    }
    if (starRate == 8) {
      return '40%'
    }
    if (starRate == 9) {
      return '45%'
    }
    if (starRate == 10) {
      return '50%'
    }
    if (starRate == 11) {
      return '55%'
    }
    if (starRate == 12) {
      return '60%'
    }
    if (starRate == 13) {
      return '65%'
    }
    if (starRate == 14) {
      return '70%'
    }
  } else {
    return ''
  }
}
Vue.prototype.getPrintName = function(printName,needHidden) {
  if(!needHidden){
    return printName
  }
  if(printName == null || printName.length == 0 || printName.length == 1){
    return printName
  }
  let returnName = printName
  if(printName.length == 2){
    returnName = printName.substr(0,1) + '*'
  }
  if(printName.length == 3){
    returnName = printName.substr(0,1) + '*' + printName.substr(2,1)
  }
  if(printName.length > 3){
    returnName = printName.substr(0,1) + '**' + printName.substr(3,printName.length - 3)
  }
  return returnName
}
Vue.prototype.getPrintPhone = function(prinHome,needHidden) {
  if(!needHidden){
    return prinHome
  }
  if(prinHome == null || prinHome.length < 9){
    return prinHome
  }
  let returnHome = prinHome.substr(0,3) + '****' + prinHome.substr(7,prinHome.length - 7)
  return returnHome
}

Vue.prototype.checkPermi = function(checkRoleList, value) {
  //** 平台管理员 || 供应商管理员 || 药店管理员 || 平台分公司 || 产品管理员 || 院外药房 || 合伙人: 100
  //** 平台管理员 : 0
  //** 供应商管理员 : 1
  //** 药店管理员 : 2
  //** 平台分公司 : 3
  //** 产品管理员 : 4
  //** 院外药房 : 5
  //** 合伙人 : 6
  const roles = store.getters && store.getters.roles
  let findOldRole = false
  if (roles != null && roles.length > 0) {
    for (var index = 0; index < roles.length; index++) {
      if (roles[index] == '平台管理员') {
        if (checkRoleList != null && checkRoleList.length) {
          for (var roleIndex = 0; roleIndex < checkRoleList.length; roleIndex++) {
            if (checkRoleList[roleIndex] == '100' || checkRoleList[roleIndex] == '0') {
              findOldRole = true
            }
          }
        } else {
          findOldRole = true
        }
      }
      if (roles[index] == '供应商管理员') {
        if (checkRoleList != null && checkRoleList.length) {
          for (var roleIndex = 0; roleIndex < checkRoleList.length; roleIndex++) {
            if (checkRoleList[roleIndex] == '100' || checkRoleList[roleIndex] == '1') {
              findOldRole = true
            }
          }
        } else {
          findOldRole = true
        }
      }
      if (roles[index] == '药店管理员'|| roles[index] == '中药药房') {
        if (checkRoleList != null && checkRoleList.length) {
          for (var roleIndex = 0; roleIndex < checkRoleList.length; roleIndex++) {
            if (checkRoleList[roleIndex] == '100' || checkRoleList[roleIndex] == '2') {
              findOldRole = true
            }
          }
        } else {
          findOldRole = true
        }
      }
      if (roles[index] == '平台分公司') {
        if (checkRoleList != null && checkRoleList.length) {
          for (var roleIndex = 0; roleIndex < checkRoleList.length; roleIndex++) {
            if (checkRoleList[roleIndex] == '100' || checkRoleList[roleIndex] == '3') {
              findOldRole = true
            }
          }
        } else {
          findOldRole = true
        }
      }
      if (roles[index] == '产品管理员') {
        if (checkRoleList != null && checkRoleList.length) {
          for (var roleIndex = 0; roleIndex < checkRoleList.length; roleIndex++) {
            if (checkRoleList[roleIndex] == '100' || checkRoleList[roleIndex] == '4') {
              findOldRole = true
            }
          }
        } else {
          findOldRole = true
        }
      }
      if (roles[index] == '院外药房') {
        if (checkRoleList != null && checkRoleList.length) {
          for (var roleIndex = 0; roleIndex < checkRoleList.length; roleIndex++) {
            if (checkRoleList[roleIndex] == '100' || checkRoleList[roleIndex] == '5') {
              findOldRole = true
            }
          }
        } else {
          findOldRole = true
        }
      }
      if (roles[index] == '合伙人') {
        if (checkRoleList != null && checkRoleList.length) {
          for (var roleIndex = 0; roleIndex < checkRoleList.length; roleIndex++) {
            if (checkRoleList[roleIndex] == '100' || checkRoleList[roleIndex] == '6') {
              findOldRole = true
            }
          }
        } else {
          findOldRole = true
        }
      }
    }
  }
  if (findOldRole) {
    return true
  }
  const all_permission = "*:*:*";
  const menuPermissionSet = store.getters && store.getters.menuPermissionSet
  if (value && value instanceof Array && value.length > 0) {
    const permissionFlag = value
    const hasPermissions = menuPermissionSet.some(permission => {
      return all_permission === permission || permissionFlag.includes(permission)
    })
    return hasPermissions
  }
  return false
}
Vue.prototype.XLSX = XLSX;
Vue.use(ElementUI, {
  locale
});
Vue.use(directive)
Vue.use(VueAMap);
Vue.use(VCharts);
Vue.use(Print);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});
VueAMap.initAMapApiLoader({
  key: '44af6b3b3c857a9962c3561761efa09b',
  //插件
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
    'AMap.Geolocation', 'AMap.Geocoder', 'AMap.AMapManager', 'AMap.Marker'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0' //ui版本
});
